// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__F624k","container":"styles_container__38PPB","title":"styles_title__1rSUJ","wrapper":"styles_wrapper__29w1h","answer":"styles_answer__PbXVK"};